import { Icon, makeStyles, useTheme } from '@rneui/themed'
import { View } from 'react-native'

interface PrevNextProps {
  onPressPrev?(): void
  onPressNext?(): void
  disabledPrev?: boolean
  disabledNext?: boolean
  children: React.ReactNode | undefined
}

export function PrevNext({
  onPressNext,
  onPressPrev,
  disabledNext,
  disabledPrev,
  children,
}: PrevNextProps) {
  const { theme } = useTheme()
  const styles = useStyles()

  return (
    <View style={styles.headerContainer}>
      <Icon
        name={'caret-square-left'}
        type="font-awesome-5"
        solid
        color={theme.colors?.grey2}
        onPress={onPressPrev}
        disabled={disabledPrev}
        style={{ marginHorizontal: 20, opacity: disabledPrev ? 0 : 1 }}
        size={30}
      />
      {children}
      <Icon
        name={'caret-square-right'}
        type="font-awesome-5"
        solid
        color={theme.colors?.grey2}
        onPress={onPressNext}
        disabled={disabledNext}
        style={{ marginHorizontal: 20, opacity: disabledNext ? 0 : 1 }}
        size={30}
      />
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  headerContainer: {
    paddingHorizontal: 10,
    flexDirection: 'row',
    height: 50,
    alignItems: 'center',
    justifyContent: 'flex-start',
    backgroundColor: theme.colors.white,
  },
}))
